import { useQuery } from "@tanstack/react-query"
import GameScreenLayout from "@/components/GameScreenLayout"
import { getBattleHistory } from "@/api/gameApi"

export default function BattleHistoryPage() {
  const q = useQuery({
    queryKey: ["battle-history"],
    queryFn: () => getBattleHistory(40),
  })

  return (
    <GameScreenLayout title="История боёв" backTo="/play/profile">
      {q.isLoading ? (
        <p className="text-sm text-guardians-muted">Загрузка…</p>
      ) : (
        <ul className="space-y-2 text-sm">
          {(q.data ?? []).map((row) => (
            <li
              key={row.id}
              className="rounded-xl border border-white/10 px-3 py-2"
            >
              <div className="flex justify-between">
                <span>{row.mode}</span>
                <span className="text-guardians-accent">{row.outcome}</span>
              </div>
              <p className="text-xs text-guardians-muted">
                vs {row.opponentNickname ?? "—"} ·{" "}
                {row.playedAt
                  ? new Date(row.playedAt).toLocaleString("ru-RU")
                  : ""}
              </p>
            </li>
          ))}
        </ul>
      )}
    </GameScreenLayout>
  )
}
